import React from 'react';
import './gpj-pages.css';

const TOPICS = [
  {
    title: 'Divorce and separation',
    description: 'Information about separation, divorce procedure, agreements, and property issues.',
    items: ['Divorce process', 'Separation agreements', 'Property division'],
    view: 'resources'
  },
  {
    title: 'Parenting arrangements',
    description: 'Information about decision-making responsibility, parenting time, and parenting plans.',
    items: ['Parenting arrangements', 'Parenting plans', 'Parenting schedules'],
    view: 'resources'
  },
  {
    title: 'Child and spousal support',
    description: 'General information about support, financial disclosure, and enforcement processes.',
    items: ['Child support guidelines', 'Spousal support', 'Support enforcement'],
    view: 'resources'
  },
  {
    title: 'Family violence and safety',
    description: 'Safety resources, emergency information, and places to find legal and community support.',
    items: ['Safety planning', 'Restraining orders', 'Emergency resources'],
    view: 'directory',
    protected: true
  },
  {
    title: 'Appeals and reviews',
    description: 'Procedural information about appeal routes, official forms, and time-sensitive next steps.',
    items: ['Review appeal route factors', 'Read condition-bound time rules', 'Open official sources'],
    view: 'appeals'
  },
  {
    title: 'Property division',
    description: 'General information about financial disclosure and property issues after separation.',
    items: ['Financial disclosure', 'Equalization', 'Matrimonial home'],
    view: 'resources'
  }
];

export default function FamilyLawTopics({ setCurrentView }) {
  return (
    <section className="gpj-section" aria-labelledby="family-law-topics-title">
      <div className="gpj-wrap">
        <div className="gpj-sec-head">
          <span className="gpj-eyebrow">Family law topics</span>
          <h2 id="family-law-topics-title">Browse by legal topic</h2>
          <p>
            Start with the subject closest to your situation. These pages provide general
            Ontario family-law information and point to procedural tools and official sources.
          </p>
        </div>

        <div className="gpj-topic-grid">
          {TOPICS.map((topic) => (
            <article
              key={topic.title}
              className={`gpj-card${topic.protected ? ' gpj-card--protected' : ''}`}
            >
              <span className="gpj-card__kicker">
                {topic.protected ? 'Safety first' : 'Ontario family law'}
              </span>
              <h3>{topic.title}</h3>
              <p className="gpj-topic-description">{topic.description}</p>
              <ul>
                {topic.items.map((item) => <li key={item}>{item}</li>)}
              </ul>
              <button
                type="button"
                className="gpj-btn gpj-btn--sm gpj-btn--ghost gpj-topic-action"
                onClick={() => setCurrentView(topic.view)}
              >
                {topic.view === 'appeals' ? 'Open appeals guide' : topic.protected ? 'Find support' : 'Browse related resources'}
              </button>
            </article>
          ))}
        </div>

        <p className="gpj-disclaimer">
          <b>This is general legal information, not legal advice.</b> Family-law rights and
          procedures depend on the facts of a case. Confirm current requirements with an
          official source or a lawyer before acting.
        </p>
      </div>
    </section>
  );
}
